module.exports = __webpack_public_path__ + "img/2025-summer-sale-am.4562d493.jpg";